/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * {
     * "optionId": "YIB0",
     * "label": "3 - 5 years in business under current authority"
     * },
     * {
         * "optionId": "YIB1",
         * "label": "1-2 years in business under current authority"
         * },
         * {
             * "optionId": "YIB2",
             * "label": "New Venture/authority with prior experience(2yr minimum)"
             * },
             * {
                 * "optionId": "YIB3",
                 * "label": "New Venture/authority with no prior experience"
                 * },
                 * {
                     * "optionId": "YIB4",
                     * "label": "Over 5 years in business under current authority"
                     * }
                     */
export var YearsInBusinessEnum;

(function (YearsInBusinessEnum) {
  YearsInBusinessEnum["YIB0"] = "YIB0";
  YearsInBusinessEnum["YIB1"] = "YIB1";
  YearsInBusinessEnum["YIB2"] = "YIB2";
  YearsInBusinessEnum["YIB3"] = "YIB3";
  YearsInBusinessEnum["YIB4"] = "YIB4";
})(YearsInBusinessEnum || (YearsInBusinessEnum = {}));